<template>
<div class="factors">
  <!-- <ui-loader v-model="loading" ref="loader" /> -->
  <v-container>
    <v-layout wrap>
      <v-flex>
        <v-form @submit="saveFactors" v-model="valid" ref="configFactorsForm" onSubmit="return false;">
          <v-card>
            <v-card-title primary-title>
              <div>
                <h1 class="d-inline-block">Listas</h1> 
                <h4 
                  class="d-inline-block" 
                  style="margin-left: 10px;"
                  v-if="statusPrices"
                  >({{statusPrices}})</h4>
              </div>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs4 class="title">
                  Minimo (Dolares)
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs2 class="title">
                  Maximo (Dolares)
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs3 class="title">
                  Porcentaje
                </v-flex>
              </v-layout>
              <v-divider mb-2></v-divider>
              <v-layout row wrap mb-2>
              </v-layout>
              <v-layout row wrap v-for="(factor, index) in percentageRanges" :key="factor.id">
                <v-flex xs4>
                  $ {{factor.min}}
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs2>
                  $ {{factor.max}}
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex xs3>
                  <v-text-field name="value" solo v-model="factor.value"></v-text-field>
                </v-flex>
              </v-layout>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" :class=" { 'blue-grey darken-2 white--text' : valid, disabled: !valid }">Guardar</v-btn>
              </v-card-actions>
              <v-snackbar v-model="snackShow" :color="snackColor" :timeout="8000" :vertical="true" top>
                {{ snckMessage }}
                <v-btn dark flat @click="snackShow = false">
                  Cerrar
                </v-btn>
              </v-snackbar>
            </v-card-text>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import {
  getFactors,
  updateFactors,
} from '../services/factors';

export default {
  name: 'PercentagesByPriceRange',
  data() {
    return {
      percentageRanges: [],
      loading: false,
      snackShow: false,
      snackColor: 'green',
      snckMessage: '',
      valid: true,
      error: '',
      statusPrices: ''
    };
  },
  methods: {
    saveFactors() {
      this.loading = true;
      updateFactors(this.percentageRanges)
        .then((result) => {
          this.loading = false;
          if(result.data.statusCode === 226){
            this.snackColor = 'red';
            this.snckMessage = 'Servicio actualizando histórico y productos. Intente mas tarde';
          }else{
            this.snackColor = 'green';
            this.snckMessage = 'Actualizados factores y precios';
          }
          setTimeout(() => {
            this.checkPriceStatus()
          }, 1000);
          this.snackShow = true;

        })
        .catch((err) => {
          this.loading = false;
          this.snackShow = true;
          this.snackColor = 'red';
          this.snckMessage = 'Error servicio';
          // this.err = err.message;
        });
    },
    async checkPriceStatus() {
      const statusPrice = await this.axios.get('/catalogs/product/status/update');
      this.updatedStatusText(statusPrice.data.updateStatus)
    },
    updatedStatusText(code) {
      switch(code) {
        case 'NONE':
          this.statusPrices = 'Sin cambios pendientes de actualizar'
          break;
        case 'PENDING':
          this.statusPrices = 'Actualización de precios programada'
          break;
        case 'UPDATING':
          this.statusPrices = 'Actualización en curso'
          break;
      }
    },
  },
  mounted() {
    this.checkPriceStatus()
    getFactors()
      .then((res) => {
        this.percentageRanges = res.data;
      });
  },
};
</script>
